module.exports = __webpack_public_path__ + "static/favicon-1382359f450c77aa6a3a274bf801b389.ico";